module.exports = __webpack_public_path__ + "static/confident-business-woman-22f891354cb58e1d95a85fdf285cb4b6.jpg";